import { Component, Input } from '@angular/core';

/** Styles do badge */
interface Styles {
    fontSize?: string;
    padding?: string;
}

@Component({
    selector: 'sgt-pedido-fracionado-badge',
    templateUrl: './pedido-fracionado-badge.component.html',
    styleUrls: ['./pedido-fracionado-badge.component.less']
})
export class PedidoFracionadoBadgeComponent {
    @Input() title = 'Pedido Fracionado';
    @Input() label = 'Fracionado';
    /** Styles personalizados do badge */
    @Input() styles: Styles = {
        padding: '0.4rem'
    };
}
